import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import MultiselectFilter from 'components/Filter/MultiselectFilter';
import {
    SUB_TYPE_LIST,
} from 'constants/ticket';

const CustomTypeFilter = ({ selected, onChange, isForcedOpen, disabled }) => {
    const options = SUB_TYPE_LIST.map(type => ({
        value: type,
        text: I18n.t(`ticket.sub_type_${ type }`),
    }));

    return (
        <MultiselectFilter
            title={ I18n.t('ticket.sub_type') }
            options={ options }
            defaultSelected={ selected }
            onChange={ onChange }
            isForcedOpen={ isForcedOpen }
            disabled={ disabled }
        />
    );
};
CustomTypeFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    selected: PropTypes.arrayOf(PropTypes.number),
    isForcedOpen: PropTypes.bool,
    disabled: PropTypes.bool,
};
CustomTypeFilter.defaultProps = {
    selected: [],
    isForcedOpen: false,
    disabled: false,
};

export default CustomTypeFilter;
